import { render, staticRenderFns } from "./shareForm.vue?vue&type=template&id=7568e71d&"
import script from "./shareForm.vue?vue&type=script&lang=js&"
export * from "./shareForm.vue?vue&type=script&lang=js&"
import style0 from "./shareForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "shareForm.vue"
export default component.exports